module.exports = __webpack_public_path__ + "static/TheSiliconReview-e40d5ff37778f06a292cbb434543bb53.svg";